import { FC, ReactNode } from 'react';
import { useTheme } from '@mui/material';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import {
  OutletBox,
  ParentLayoutBox
} from 'src/components/StyledComponents/ParentLayout';

interface ParentHeaderProps {
  children?: ReactNode;
}

const ParentHeader: FC<ParentHeaderProps> = () => {
  const theme = useTheme();

  return (
    <>
      <ParentLayoutBox>
        <Header />
        <OutletBox>
          <Outlet />
        </OutletBox>
      </ParentLayoutBox>
    </>
  );
};

export default ParentHeader;
